(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["estimated-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
  var fromOffsetDays = 3;
  var toOffsetDays = 8;

  var fromDateEl = document.getElementById('ctm-estimated-delivery-from-date');
  var toDateEl = document.getElementById('ctm-estimated-delivery-to-date');
  var countdownEl = document.getElementById('ctm-estimated-delivery-countdown');

  if (!fromDateEl || !toDateEl || !countdownEl) return;

  function addDays(baseDate, days) {
    var date = new Date(baseDate.getTime());
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatDate(date) {
    var options = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  var now = new Date();
  var fromDate = addDays(now, fromOffsetDays);
  var toDate = addDays(now, toOffsetDays);

  fromDateEl.textContent = formatDate(fromDate);
  toDateEl.textContent = formatDate(toDate);

  function updateCountdown() {
    var now = new Date();
    var endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999
    );

    var remaining = endOfDay.getTime() - now.getTime();

    if (remaining <= 0) {
      countdownEl.textContent = '0H 0M 0S';
      return;
    }

    var hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    var minutes = Math.floor((remaining / (1000 * 60)) % 60);
    var seconds = Math.floor((remaining / 1000) % 60);

    var text = hours + 'H : ' + minutes + 'M : ' + seconds + 'S';
    
    // Simply update the text - no view transition needed
    countdownEl.textContent = text;

    window.setTimeout(updateCountdown, 1000);
  }

  updateCountdown();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-ctm"] && !Shopify.designMode) return;
  try {
    class ProductGallerySlider extends HTMLElement {
  connectedCallback() {
    if (this.galleryInitialized || typeof Swiper === 'undefined') return;

    this.gallery = this.closest('.pgs-gallery');
    if (!this.gallery) return;

    this.galleryInitialized = true;
    this.thumbsLeft = this.gallery.classList.contains('pgs-gallery--thumbs-left');
    this.desktopQuery = window.matchMedia('(min-width: 1200px)');
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleBreakpointChange = this.updateThumbOrientation.bind(this);
    this.handleThumbnailClick = this.onThumbnailClick.bind(this);
    this.handleThumbnailKeydown = this.onThumbnailKeydown.bind(this);
    this.handleMainImageClick = this.onMainImageClick.bind(this);
    this.handleViewerClick = this.onViewerClick.bind(this);
    this.handleViewerKeydown = this.onViewerKeydown.bind(this);
    this.handleViewerClose = this.onViewerClose.bind(this);

    const thumbsElement = this.gallery.querySelector('.pgs-thumbs');
    this.thumbsElement = thumbsElement;
    this.viewer = this.gallery.querySelector('[data-pgs-viewer]');
    this.viewerMainElement = this.gallery.querySelector('[data-pgs-viewer-main]');
    const scrollbarElement = this.gallery.querySelector('[data-pgs-scrollbar]');
    const speed = this.reducedMotionQuery.matches ? 0 : 300;

    if (thumbsElement) {
      this.thumbsSwiper = new Swiper(thumbsElement, {
        slidesPerView: this.visibleThumbCount(),
        spaceBetween: 8,
        watchOverflow: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        loop: false,
        direction: this.isVertical() ? 'vertical' : 'horizontal',
        roundLengths: true,
        speed,
        a11y: {
          enabled: false,
        },
        navigation: {
          nextEl: this.gallery.querySelector('.thumb-next'),
          prevEl: this.gallery.querySelector('.thumb-prev'),
        },
        scrollbar: {
          el: scrollbarElement,
          draggable: true,
          hide: false,
          snapOnRelease: true,
        },
        mousewheel: {
          enabled: this.isVertical(),
          forceToAxis: true,
          releaseOnEdges: true,
        },
      });
    }

    const mainOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      rewind: true,
      grabCursor: true,
      watchOverflow: true,
      speed,
      a11y: {
        enabled: false,
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      on: {
        init: (swiper) => this.updateGalleryState(swiper),
        slideChange: (swiper) => this.updateGalleryState(swiper),
      },
    };

    const previousButton = this.querySelector('.pgs-main__arrow--prev');
    const nextButton = this.querySelector('.pgs-main__arrow--next');

    if (previousButton && nextButton) {
      mainOptions.navigation = {
        prevEl: previousButton,
        nextEl: nextButton,
      };
    }

    this.mainSwiper = new Swiper(this, mainOptions);
    this.addEventListener('click', this.handleMainImageClick);

    if (this.thumbsElement) {
      this.thumbsElement.addEventListener('click', this.handleThumbnailClick, true);
      this.thumbsElement.addEventListener('keydown', this.handleThumbnailKeydown);

      if (typeof ResizeObserver !== 'undefined') {
        this.railResizeObserver = new ResizeObserver(() => this.updateThumbRailSize());
        this.railResizeObserver.observe(this);
      }

      this.updateThumbRailSize();
      this.updateOverflowTrigger();
    }

    if (this.viewer) {
      this.viewer.addEventListener('click', this.handleViewerClick);
      this.viewer.addEventListener('keydown', this.handleViewerKeydown);
      this.viewer.addEventListener('close', this.handleViewerClose);
    }

    if (this.thumbsLeft) {
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleMainImageClick);

    if (this.thumbsElement) {
      this.thumbsElement.removeEventListener('click', this.handleThumbnailClick, true);
      this.thumbsElement.removeEventListener('keydown', this.handleThumbnailKeydown);
    }

    if (this.viewer) {
      this.viewer.removeEventListener('click', this.handleViewerClick);
      this.viewer.removeEventListener('keydown', this.handleViewerKeydown);
      this.viewer.removeEventListener('close', this.handleViewerClose);

      if (this.viewer.open) {
        this.viewerOpener = null;
        this.viewer.close();
      }
    }

    this.unlockPageScroll();

    if (this.railResizeObserver) {
      this.railResizeObserver.disconnect();
    }

    if (this.thumbsLeft && this.desktopQuery && this.handleBreakpointChange) {
      this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
    }

    if (this.mainSwiper && !this.mainSwiper.destroyed) {
      this.mainSwiper.destroy(true, true);
    }

    if (this.thumbsSwiper && !this.thumbsSwiper.destroyed) {
      this.thumbsSwiper.destroy(true, true);
    }

    if (this.viewerSwiper && !this.viewerSwiper.destroyed) {
      this.viewerSwiper.destroy(true, true);
    }

    this.mainSwiper = null;
    this.thumbsSwiper = null;
    this.viewerSwiper = null;
    this.thumbsElement = null;
    this.viewer = null;
    this.viewerMainElement = null;
    this.viewerOpener = null;
    this.railResizeObserver = null;
    this.galleryInitialized = false;
  }

  isVertical() {
    return this.thumbsLeft && this.desktopQuery.matches;
  }

  visibleThumbCount() {
    return this.isVertical() ? 6 : 4;
  }

  updateThumbOrientation() {
    if (!this.thumbsSwiper || this.thumbsSwiper.destroyed) return;

    const vertical = this.isVertical();
    this.thumbsSwiper.changeDirection(vertical ? 'vertical' : 'horizontal', false);
    this.thumbsSwiper.params.slidesPerView = this.visibleThumbCount();
    this.updateThumbRailSize();
    this.updateOverflowTrigger();

    if (this.thumbsSwiper.mousewheel) {
      if (vertical) {
        this.thumbsSwiper.mousewheel.enable();
      } else {
        this.thumbsSwiper.mousewheel.disable();
      }
    }

    this.thumbsSwiper.update();

    if (this.thumbsSwiper.scrollbar) {
      this.thumbsSwiper.scrollbar.updateSize();
    }
  }

  updateThumbRailSize() {
    if (!this.thumbsElement || !this.thumbsSwiper || this.thumbsSwiper.destroyed) return;

    const targetHeight = this.isVertical()
      ? `${Math.max(240, Math.round(this.getBoundingClientRect().width) - 56)}px`
      : '';

    if (this.thumbsElement.style.height === targetHeight) return;

    this.thumbsElement.style.height = targetHeight;
    this.thumbsSwiper.update();

    if (this.thumbsSwiper.scrollbar) {
      this.thumbsSwiper.scrollbar.updateSize();
    }
  }

  onThumbnailClick(event) {
    const button = event.target.closest('[data-pgs-thumb-index]');
    if (!button || !this.mainSwiper) return;

    const index = Number.parseInt(button.dataset.pgsThumbIndex, 10);

    if (button.hasAttribute('data-pgs-overflow-trigger')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openViewer(index, button);
      return;
    }

    this.mainSwiper.slideTo(index);
  }

  onThumbnailKeydown(event) {
    const button = event.target.closest('[data-pgs-thumb-index]');
    if (!button || !this.mainSwiper) return;

    const buttons = Array.from(this.gallery.querySelectorAll('[data-pgs-thumb-index]:not([hidden])'));
    const currentPosition = buttons.indexOf(button);
    let nextPosition = currentPosition;

    if (currentPosition < 0) return;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextPosition = Math.min(currentPosition + 1, buttons.length - 1);
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextPosition = Math.max(currentPosition - 1, 0);
    } else if (event.key === 'Home') {
      nextPosition = 0;
    } else if (event.key === 'End') {
      nextPosition = buttons.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    const nextButton = buttons[nextPosition];
    this.mainSwiper.slideTo(Number.parseInt(nextButton.dataset.pgsThumbIndex, 10));
    nextButton.focus();
  }

  updateOverflowTrigger() {
    const buttons = Array.from(this.gallery.querySelectorAll('[data-pgs-thumb-index]'));

    buttons.forEach((button) => {
      const badge = button.querySelector('[data-pgs-overflow-badge]');
      button.hidden = false;
      button.classList.remove('pgs-thumbs__slide--overflow');
      button.removeAttribute('data-pgs-overflow-trigger');
      button.removeAttribute('aria-haspopup');
      button.setAttribute('aria-label', button.dataset.pgsDefaultLabel || '');
      button.setAttribute('aria-controls', `${this.id}-slides`);

      if (badge) {
        badge.hidden = true;
        badge.textContent = '';
      }
    });

    const visibleCount = this.visibleThumbCount();
    if (!this.viewer || buttons.length <= visibleCount) {
      this.refreshThumbRail();
      return;
    }

    const triggerIndex = visibleCount - 1;
    const remainingCount = buttons.length - triggerIndex;
    const trigger = buttons[triggerIndex];
    const badge = trigger.querySelector('[data-pgs-overflow-badge]');
    const template = this.gallery.dataset.pgsOverflowTemplate;

    buttons.slice(triggerIndex + 1).forEach((button) => {
      button.hidden = true;
      button.tabIndex = -1;
      button.setAttribute('aria-current', 'false');
    });

    trigger.classList.add('pgs-thumbs__slide--overflow');
    trigger.setAttribute('data-pgs-overflow-trigger', '');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', this.viewer.id);

    if (template) {
      trigger.setAttribute('aria-label', template.replace('__count__', remainingCount));
    }

    if (badge) {
      badge.textContent = `${remainingCount}+`;
      badge.hidden = false;
    }

    this.refreshThumbRail();
  }

  refreshThumbRail() {
    if (this.thumbsSwiper && !this.thumbsSwiper.destroyed) {
      this.thumbsSwiper.update();

      if (this.thumbsSwiper.scrollbar) {
        this.thumbsSwiper.scrollbar.updateSize();
      }
    }

    if (this.mainSwiper && !this.mainSwiper.destroyed) {
      this.updateGalleryState(this.mainSwiper);
    }
  }

  onMainImageClick(event) {
    const button = event.target.closest('[data-pgs-open-viewer]');
    if (!button) return;

    this.openViewer(Number.parseInt(button.dataset.pgsOpenViewer, 10), button);
  }

  openViewer(index, opener) {
    if (!this.viewer || !this.viewerMainElement) return;

    this.viewerOpener = opener;

    if (!this.viewer.open) {
      this.viewer.showModal();
    }

    document.documentElement.classList.add('pgs-viewer-open');
    document.body.classList.add('pgs-viewer-open');
    this.initializeViewer();

    const lastIndex = this.viewerSwiper.slides.length - 1;
    const targetIndex = Math.min(Math.max(index, 0), lastIndex);
    this.viewerSwiper.update();
    this.viewerSwiper.slideTo(targetIndex, 0);
    this.updateViewerState(this.viewerSwiper);

    window.requestAnimationFrame(() => {
      this.viewer.querySelector('[data-pgs-viewer-close]')?.focus();
    });
  }

  initializeViewer() {
    if (this.viewerSwiper && !this.viewerSwiper.destroyed) return;

    const speed = this.reducedMotionQuery.matches ? 0 : 300;
    const viewerOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      rewind: true,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      speed,
      a11y: {
        enabled: false,
      },
      on: {
        init: (swiper) => this.updateViewerState(swiper),
        slideChange: (swiper) => this.updateViewerState(swiper),
      },
    };

    const previousButton = this.viewer.querySelector('[data-pgs-viewer-prev]');
    const nextButton = this.viewer.querySelector('[data-pgs-viewer-next]');

    if (previousButton && nextButton) {
      viewerOptions.navigation = {
        prevEl: previousButton,
        nextEl: nextButton,
      };
    }

    this.viewerSwiper = new Swiper(this.viewerMainElement, viewerOptions);
  }

  onViewerClick(event) {
    if (event.target === this.viewer || event.target.closest('[data-pgs-viewer-close]')) {
      this.viewer.close();
      return;
    }

    const thumbnail = event.target.closest('[data-pgs-viewer-thumb-index]');
    if (!thumbnail || !this.viewerSwiper) return;

    this.viewerSwiper.slideTo(Number.parseInt(thumbnail.dataset.pgsViewerThumbIndex, 10));
  }

  onViewerKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.viewer.close();
      return;
    }

    if (!this.viewerSwiper || event.target.closest('[data-pgs-viewer-close]')) return;

    const thumbnail = event.target.closest('[data-pgs-viewer-thumb-index]');
    const currentIndex = Number.isFinite(this.viewerSwiper.realIndex)
      ? this.viewerSwiper.realIndex
      : this.viewerSwiper.activeIndex;
    const lastIndex = this.viewerSwiper.slides.length - 1;
    const thumbnailColumns = this.desktopQuery.matches
      ? this.viewerThumbnailColumnCount()
      : 1;
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = Math.min(currentIndex + 1, lastIndex);
    } else if (event.key === 'ArrowLeft') {
      nextIndex = Math.max(currentIndex - 1, 0);
    } else if (thumbnail && event.key === 'ArrowDown') {
      nextIndex = Math.min(currentIndex + thumbnailColumns, lastIndex);
    } else if (thumbnail && event.key === 'ArrowUp') {
      nextIndex = Math.max(currentIndex - thumbnailColumns, 0);
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = lastIndex;
    } else {
      return;
    }

    event.preventDefault();
    this.viewerSwiper.slideTo(nextIndex);

    if (thumbnail) {
      this.viewer.querySelector(`[data-pgs-viewer-thumb-index="${nextIndex}"]`)?.focus();
    }
  }

  viewerThumbnailColumnCount() {
    const thumbnailContainer = this.viewer?.querySelector('[data-pgs-viewer-thumbs]');
    if (!thumbnailContainer) return 1;

    const columns = window.getComputedStyle(thumbnailContainer).gridTemplateColumns;
    if (!columns || columns === 'none') return 1;

    return Math.max(columns.split(' ').filter(Boolean).length, 1);
  }

  onViewerClose() {
    this.unlockPageScroll();

    const opener = this.viewerOpener;
    this.viewerOpener = null;

    if (opener?.isConnected) {
      window.requestAnimationFrame(() => opener.focus());
    }
  }

  unlockPageScroll() {
    document.documentElement.classList.remove('pgs-viewer-open');
    document.body.classList.remove('pgs-viewer-open');
  }

  updateViewerState(swiper) {
    const activeIndex = Number.isFinite(swiper.realIndex) ? swiper.realIndex : swiper.activeIndex;
    this.updateSlideAccessibility('.pgs-viewer__slide', activeIndex);
    const thumbnailButtons = this.viewer.querySelectorAll('[data-pgs-viewer-thumb-index]');

    thumbnailButtons.forEach((button, index) => {
      const active = index === activeIndex;
      button.setAttribute('aria-current', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;

      if (active) {
        button.scrollIntoView({
          behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    });

    const status = this.viewer.querySelector('[data-pgs-viewer-status]');
    const statusTemplate = this.viewer.dataset.pgsViewerStatusTemplate;

    if (status && statusTemplate) {
      status.textContent = statusTemplate
        .replace('__current__', activeIndex + 1)
        .replace('__total__', swiper.slides.length);
    }
  }

  updateGalleryState(swiper) {
    const activeIndex = Number.isFinite(swiper.realIndex) ? swiper.realIndex : swiper.activeIndex;
    this.updateSlideAccessibility('.pgs-main__slide', activeIndex, '[data-pgs-open-viewer]');
    const thumbnailButtons = this.gallery.querySelectorAll('[data-pgs-thumb-index]:not([hidden])');

    thumbnailButtons.forEach((button) => {
      const mediaIndex = Number.parseInt(button.dataset.pgsThumbIndex, 10);
      const active = button.hasAttribute('data-pgs-overflow-trigger')
        ? activeIndex >= mediaIndex
        : activeIndex === mediaIndex;
      button.setAttribute('aria-current', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });

    const status = this.gallery.querySelector('[data-pgs-status]');
    const statusTemplate = this.gallery.dataset.pgsStatusTemplate;

    if (status && statusTemplate) {
      status.textContent = statusTemplate
        .replace('__current__', activeIndex + 1)
        .replace('__total__', swiper.slides.length);
    }
  }

  updateSlideAccessibility(slideSelector, activeIndex, focusableSelector = '') {
    const slides = this.gallery.querySelectorAll(slideSelector);

    slides.forEach((slide, index) => {
      const active = index === activeIndex;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.toggleAttribute('inert', !active);

      if (!focusableSelector) return;

      slide.querySelectorAll(focusableSelector).forEach((control) => {
        control.tabIndex = active ? 0 : -1;
      });
    });
  }
}

if (!customElements.get('product-gallery-slider')) {
  customElements.define('product-gallery-slider', ProductGallerySlider);
}
  } catch(e) { console.error(e); }
})();

})();
